export default __webpack_public_path__ + "73bd1ad3c55e3dc5ad7f9728065d7353.png";